import styled from "styled-components";
import pixelToRem from "../../utils/pxToRem";
import { device } from "../../styles/responsive";

import { IconProps } from ".";

export const DivIcon = styled.article`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: ${pixelToRem(12)};
  min-height: ${pixelToRem(144)};
  padding: ${pixelToRem(20)};
  border: 1px solid var(--border-soft);
  border-radius: ${pixelToRem(12)};
  background: rgba(32, 32, 32, 0.92);
  box-shadow: var(--shadow-soft);
  min-width: 0;

  @media ${device.mobile} {
    align-items: center;
    text-align: center;
    min-height: auto;
    padding: ${pixelToRem(16)};
  }
`;

type ImageProps = Omit<IconProps, "txt">;

export const ImageIcon = styled.img<ImageProps>`
  width: ${pixelToRem(48)};
  height: ${pixelToRem(48)};
  object-fit: contain;
`;

export const TextIcon = styled.p`
  color: var(--text-secondary);
  font: var(--text-1);
  line-height: 1.6;
  text-wrap: pretty;

  @media ${device.mobile} {
    font-size: ${pixelToRem(14)};
    line-height: 1.55;
  }
`;
